<template>
	<div>
		<navigation></navigation>
		<div class="line"></div>
		<!-- 组织机构 -->
		<div style="margin-left: 20px;">
			<div class="we-title lianxi" style="margin-top: 30px;">注册咨询</div>
			<div v-for="(item,index) in contactUsList">
				<span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
			</div>
			<div style="margin: 30px 0;">
			<div class="we-title lianxi" style="margin-top: 10px;">住宿订房</div>
			<div v-for="(item,index) in contactUsListTwo">
				<span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
			</div>
			</div>
			<div class="we-title lianxi" style="margin-top: 10px;">企业参会</div>
			<div v-for="(item,index) in contactUsListThree">
				<span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
			</div>
      <div class="we-title lianxi" style="margin-top: 10px;">线上支持</div>
      <div v-for="(item,index) in contactUsListFour">
        <span class="we-title">{{item.title}}</span> <span style="font-size: 14px;">{{item.content}}</span>
      </div>
		</div>
		<logocom style="margin-top: 150px;"></logocom>
	</div>
</template>

<script>
	import logocom from '@/components/logo/logo.vue';
	import navigation from '@/components/navigation/navigation.vue';
	export default{
		data(){
			return{
				contactUsList: [{
						title: '联系人:',
						content: '瞿韦平'
					},
					{
						title: '电话:',
						content: '180-1600-8787'
					},
					{
						title: '邮箱:',
						content: 'quwp@fumed.com.cn'
					},
				],
				
				contactUsListTwo: [{
						title: '联系人:',
						content: '彭悦'
					},
					{
						title: '电话:',
						content: '173 1728 2021，021-64453107（转BISC感染会项目组）'
					},
					{
						title: '邮箱:',
						content: 'pengyue@fumed. com.cn'
					},
				],
				contactUsListThree: [{
						title: '联系人:',
						content: '朱永赞'
					},
					{
						title: '电话:',
						content: '010-51322757'
					},
					{
						title: '邮箱:',
						content: 'zhuyz@cma.org.cn'
					},
				],
        contactUsListFour:[{
          title:'联系人:',
          content:'贺淼',
        },{
          title:'电话:',
          content:'183-1038-0289',
        },{
          title:'邮箱:',
          content:'ganzhiyuhm@163.com',
        }],
			}
		},
		methods:{
			
		},
		components:{
			navigation,
			logocom
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (!flag) {
				this.$router.push({
					path: '/'
				})
			};
		
		},
	}
</script>

<style scoped>
	.we-title {
		font-size: 14px;
		color: #000000;
		font-weight: bold;
		line-height: 25px;
	}
	
	.lianxi {
		color: #757575;
		font-size: 15px;
		
	}
	
</style>
